export default __webpack_public_path__ + "static/media/logo-pinjam-modal.c3bfc550.svg";